export const getAppVariant = () => {
  const runtimeConfig = useRuntimeConfig()
  const variant = runtimeConfig.app.appVariant || runtimeConfig.public.appVariant
  if (!variant) {
    return 'main'
  }
  return variant
}
